import excavation1 from '../../assets/excavation1.jpg'
import excavation2 from '../../assets/excavation2.jpg'
import excavation3 from '../../assets/excavation3.jpg'
import excavation4 from '../../assets/excavation4.jpg'
import excavation5 from '../../assets/excavation5.jpg'
import excavation6 from '../../assets/excavation6.jpg'
import excavation7 from '../../assets/excavation7.jpg'

import foot1 from '../../assets/foot1.jpg'
import foot2 from '../../assets/foot2.jpg'
import foot3 from '../../assets/foot3.jpg'
import foot4 from '../../assets/foot4.jpg'
import foot5 from '../../assets/foot5.jpg'

import rock1 from '../../assets/rock1.jpg'
import rock2 from '../../assets/rock2.jpg'
import rock3 from '../../assets/rock3.jpg'
import rock4 from '../../assets/rock4.jpg'
import rock5 from '../../assets/rock5.jpg'
import rock6 from '../../assets/rock6.jpg'
import rock7 from '../../assets/rock7.jpg'
import rock8 from '../../assets/rock8.jpg'

import util1 from '../../assets/util1.jpg';
import util2 from '../../assets/util2.jpg';
import util5 from '../../assets/utility1.jpg';
import util6 from '../../assets/utility2.jpg';
import util4 from '../../assets/utility4.jpg';

import demo1 from '../../assets/demo1.jpg'
import demo2 from '../../assets/demo2.jpg'
import demo3 from '../../assets/demo3.jpg'
import demo4 from '../../assets/demo4.jpg'



export const Excavation = [
excavation1,
excavation2,
excavation3,
excavation4,
excavation5,
excavation6,
excavation7,
]

export const Footings = [
  foot1, 
  foot2,
  foot3,
  foot4,
  foot5,
]

export const Rocks = [
  rock1,
  rock2,
  rock3,
  rock4,
  rock5,
  rock6,
  rock7,
  rock8, 
]

export const Utilities = [
  util1,
  util2,
  util4,
  util5,
  util6,
]

export const Demo = [
  demo1,
  demo2,
  demo3,
  demo4,
]